import { appStartTime } from './app-start-time.js';
import { socketStream } from './socket-stream.js';
import { Position } from './entities/position.js';
import { PositionClosed } from './entities/position-closed.js';

class AccountEvents {
	constructor() {
		this.openPositions = null;
		this.closedPositions = null;
        this.openPosUpdatedHandlers = {};
        this.closedPosUpdatedHandlers = {};
	}

	readLastEvents() {
		let lastTime = appStartTime.getLastTime();
		//console.log(`Last time app started: ${lastTime} (${lastTime.getTime()})`);
		let subMsg = JSON.stringify({
			ClassName: "OrderEventsSubscription",
			Timestamp: lastTime.getTime() / 1000 //- 60 * 1440 * 10
		});
		socketStream.addChannelHandler('OrderEvents', 'AccountEventsStore', (data) => {
			let records = this.parseServerEvents(data);
			if (records.opened.length)
				this.callHandlers(records.opened, this.openPosUpdatedHandlers);
			if (records.closed.length)
				this.callHandlers(records.closed, this.closedPosUpdatedHandlers);
		});
		socketStream.subscribeOnConnect(() => {
			socketStream.socket.send(subMsg);
		});
    }
    
	parseServerEvents(data) {
		let evts = {
			opened: [],
			closed: []
		};
		if (!data || data.length !== 2) return evts;
		try {
			evts.opened = Position.parsePositionsArray(data[0]);
			evts.closed = PositionClosed.parsePositionsArray(data[1]);
			//console.log(`evts.opened: ${evts.opened.length}, evts.closed: ${evts.closed.length}`);
			return evts;
		} catch (e) {
			//console.log('Error parsing order events from server:')
			//console.log(e);
			return evts;
		}
	}

	subscribeOnPosOpened(handlerId, handler) {
        this.openPosUpdatedHandlers[handlerId] = handler;
	}

	subscribeOnPosClosed(handlerId, handler) {
		this.closedPosUpdatedHandlers[handlerId] = handler;
    }
    
	updateOpenPositions(positions) {
		if (!positions) return;
		//console.log(`updatePositions(${positions.length})`);
		if (!this.openPositions) {
			this.openPositions = {};
			for (let i = 0; i < positions.length; i++)
				this.openPositions[positions[i].id] = positions[i];
			return;
		}

		let excludedPositions = [];
		let actualIds = {};
		for (let i = 0; i < positions.length; i++)
			actualIds[positions[i].id] = true;
		for (let id in this.openPositions) {
			if (!actualIds[id]) {
				excludedPositions.push(this.openPositions[id]);
				delete this.openPositions[id];
			}
		}

		let newPos = [];
		for (let i = 0; i < positions.length; i++) {
			let pos = positions[i];
			if (this.openPositions[pos.id]) continue;
			this.openPositions[pos.id] = pos;
			newPos.push(pos);
		}
		if (newPos.length)
			this.callHandlers(newPos, this.openPosUpdatedHandlers);
		if (excludedPositions.length)
			this.callHandlers(excludedPositions, this.closedPosUpdatedHandlers);
	}

	callHandlers(newPos, handlersHash) {
		for (let id in handlersHash) {
			try {
				//console.log(`callHandlers(${id}, ${newPos.length})`);
				handlersHash[id](newPos);
			} catch (e) {
                //console.log(`callHandlers(${id}, ${newPos.length})`);
			}
		}
	}
}

export let accountEvents = new AccountEvents();